import { render, staticRenderFns } from "./ChangetrackingTable.vue?vue&type=template&id=c2eb4f66&"
import script from "./ChangetrackingTable.vue?vue&type=script&lang=js&"
export * from "./ChangetrackingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports